import { useState } from "react";
import endpointPayApi from "./Axios";

const useGenPdf = ({ api }) => {
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const reset = () => {
    setPdfUrl(null);
    setLoading(false);
  };

  const onCall = async ({ headers, params }) => {
    setLoading(true);
    try {
      let result;
      result = await endpointPayApi.get(api, { headers, params });
      setLoading(false);
      setPdfUrl(result.data?.response?.["PDF File URL"]);
      return Promise.resolve(result.data?.response?.["PDF File URL"]);
    } catch (err) {
      setPdfUrl("");
      setLoading(false);
      return Promise.reject(err);
    }
  };

  return {
    loading,
    pdfUrl,
    reset,
    onCall,
  };
};

export default useGenPdf;
